module.exports = require("@tiptap/extension-code");